// ============================================================================
// EXPENSE VOUCHER ENDPOINTS — Phase G
// ============================================================================
// Backend: ExpenseController → /api/v1/Expense.

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

export const EXPENSE_BASE_PATH = '/Expense';

export const expenseEndpoints = {
  list: () => buildEndpoint(EXPENSE_BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${EXPENSE_BASE_PATH}/:id`, { id }),
  create: () => buildEndpoint(EXPENSE_BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${EXPENSE_BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${EXPENSE_BASE_PATH}/:id`, { id }),
  computeApportionment: () => buildEndpoint(`${EXPENSE_BASE_PATH}/compute-apportionment`),
  byCase: (caseId: ID) => buildEndpointWithParams(`${EXPENSE_BASE_PATH}/by-case/:caseId`, { caseId }),
  byCaseGroup: (caseGroupId: ID) => buildEndpointWithParams(`${EXPENSE_BASE_PATH}/by-case-group/:caseGroupId`, { caseGroupId }),
} as const;

export default expenseEndpoints;
